import { ProductApiGridColumnFieldValue } from "./product-api-grid-column-field-value.model";

export class ProductApiGridCell {
  columnName: string;
  defaultDisplayValue: string;
  overrideDisplayValue: string;
  dnaLocked: boolean;
  updateLocked: boolean;
  productApiMappedFieldId: number;
  productApiId: number;
  productApiProductId: number;
  fieldValues: ProductApiGridColumnFieldValue[]
  updateInProgress: boolean;
}
